import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { styled } from "@mui/material/styles";
import { useMediaQuery } from '@mui/material';
import { Box, Grid, Typography } from "@mui/material";
import { useI18n } from "react-simple-i18n";

import { GET_BROWSE_COURSE } from "../../components/graphql";
import { SecondGlobalSpacing } from "../../components/layout/styles";
import { SecondOutlineButton } from "../../components/buttons/buttons";
import { CourseCard, CourseCardSkeleton } from "../components/courseCard";
import { useCustomNavigate } from "../../provider/navigate";

const emptyArray = new Array(4).fill(0);

const TopCourse = () => {
	const { t } = useI18n();
	const { customNavigate } = useCustomNavigate();

	let showItems = 4;
	const isXl = useMediaQuery(`(max-width: 1536px)`);
	const isMd = useMediaQuery(`(max-width: 1280px)`);
	const isXs = useMediaQuery(`(max-width: 768px)`);

	if (isXl) showItems = 3;
	if (isMd) showItems = 2;
	if (isXs) showItems = 1;

	const { data: browseCourse, loading, error } = useQuery(GET_BROWSE_COURSE, {
		variables: { lectureType: "top" },
		pollInterval: 5000,
	})

	const courseDatas: CourseObject[] = useMemo(() => {
		if (!!loading || !!error) return [];
		return browseCourse.getBrowseCourse;
	}, [browseCourse, loading, error])

	return (
		<SecondGlobalSpacing>
			<TopCourseWrapper>
				<Contents>
					<Typography variant="h3">
						{t("topCourse.title")}
					</Typography>

					<Typography variant="body1">
						{t("topCourse.description")}
					</Typography>

					<SecondOutlineButton onClick={customNavigate("/browseCourse")}>
						<Typography>{t("buttons.startJourney")}</Typography>
					</SecondOutlineButton>
				</Contents>

				<TopCourseContainer>
					{(!loading && !error) && (
						<Grid container spacing={2}>
							{courseDatas.slice(0, showItems).map((data: CourseObject, key: number) => (
								<Grid item xs={12} md={6} xl={4} xl2={3} key={key}>
									<CourseCard data={data} type="" />
								</Grid>
							))}
						</Grid>
					)}

					{(!!loading || !!error) && (
						<Grid container spacing={2}>
							{emptyArray.slice(0, showItems).map((i, key: number) => (
								<Grid item xs={12} md={6} lg={6} xl={4} xl2={3} key={key}>
									<CourseCardSkeleton />
								</Grid>
							))}
						</Grid>
					)}
				</TopCourseContainer>
			</TopCourseWrapper>
		</SecondGlobalSpacing>
	)
}

const TopCourseWrapper = styled(Box)(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: '350px 1fr',
	gap: theme.spacing(3),

	borderRadius: 30,
	padding: theme.spacing(5),
	backgroundColor: theme.palette.common.sectionBg,

	[theme.breakpoints.down("lg")]: {
		gridTemplateColumns: '1fr',
	},

	[theme.breakpoints.down("md")]: {
		gap: theme.spacing(2),
		padding: theme.spacing(3),
		borderRadius: 20,
	}
}))

const Contents = styled(Box)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: theme.spacing(2),

	p: {
		color: `${theme.palette.common.firstColor}c0`,
	},

	[theme.breakpoints.down("lg")]: {
		textAlign: "center",
	}
}))

const TopCourseContainer = styled(Box)({
	display: "flex",
	flexDirection: "column",
})

export { TopCourse }